import { useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Box from "@mui/material/Box";
import { speakers } from "../../../data/speakers";
speakers.sort((a, b) => a.lastname.toLowerCase().localeCompare(b.lastname.toLowerCase()))
const speakerCountRounded = (Math.floor(Number(speakers.length) / 10) * 10)
let res = speakers.reduce((resultArray, item, index) => {
   const chunkIndex = Math.floor(index / (speakers.length / 4));

   if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [];
   }

   resultArray[chunkIndex].push(item);

   return resultArray;
}, []);

export const Investors = () => {
   const [margin1, setMargin1] = useState("0vw");
   const [open, setOpen] = useState(false);
   const [modalInfo, setModalInfo] = useState({});
   const [chevron, setChevron] = useState(0);
   const [speakers2, setSpeakers2] = useState({ speakers: res[0], display: "none", });
   const [speakers3, setSpeakers3] = useState({ speakers: res[1], display: "none", });
   const [speakers4, setSpeakers4] = useState({ speakers: res[2], display: "none", });
   const [speakers5, setSpeakers5] = useState({ speakers: res[3], display: "none", });

   const handleClose = () => setOpen(false);

   const firstSpeakerArr = speakers.splice(0, 20).map((speaker, i) => (
      <Grid className="grid-item" key={i} item xs={1} sm={1} lg={1} xl={1} sx={{ maxWidth: '340px !important', }}>
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               alignItems: 'stretch',
               backgroundColor: 'black',
               maxWidth: '340px',
               height: '90%'
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt='investor'
               src={speaker.speaker_head_shot_to_display}
               style={{ borderRadius: "5px", width: '100%', height: "auto" }}

            />
            <div style={{ color: "white", fontSize: "1.35rem" }}>
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="turn-red"
               style={{ color: "#D215E9 !important", fontSize: "1rem" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   const secondSpeakerArr = speakers2.speakers.map((speaker, i) => (
      <Grid key={i} item xs={1} sm={1} lg={1} xl={1} sx={{ display: speakers2.display }}>
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               alignItems: 'stretch',
               backgroundColor: 'black',
               height: '90%'
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt='investor'
               src={speaker.speaker_head_shot_to_display}
               style={{ borderRadius: "5px", width: '100%', height: "auto" }}
            />
            <div className="investor-name" style={{ color: "white", fontSize: "1.35rem" }}>
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="turn-red investor-company"
               style={{ color: "#D215E9 !important", fontSize: "1rem" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   const thirdSpeakerArr = speakers3.speakers.map((speaker, i) => (
      <Grid item key={i} xs={1} sm={1} lg={1} xl={1} sx={{ display: speakers2.display }}>
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               display: speakers3.display,
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt='investor'

               src={speaker.speaker_head_shot_to_display}
               style={{ borderRadius: "5px", width: '100%', height: "auto" }}
            />
            <div className="investor-name" style={{ color: "white", fontSize: "1.35rem" }}>
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="turn-red investor-company"
               style={{ color: "#D215E9 !important", fontSize: "1rem" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   const fourthSpeakerArr = speakers4.speakers.map((speaker, i) => (
      <Grid key={i} item xs={1} sm={1} lg={1} xl={1} sx={{ display: speakers2.display }}>
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               display: speakers4.display,
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt='investor'

               src={speaker.speaker_head_shot_to_display}
               style={{ borderRadius: "5px", width: '100%', height: "auto" }}
            />
            <div className="investor-name" style={{ color: "white", fontSize: "1.35rem" }}>
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="turn-red investor-company"
               style={{ color: "#D215E9 !important", fontSize: "1rem" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   const fifthSpeakerArr = speakers5.speakers.map((speaker, i) => (
      <Grid key={i} item xs={1} sm={1} lg={1} xl={1} sx={{ display: speakers2.display }}>
         <div
            className="speaker-card"
            style={{
               borderRadius: "10px",
               margin: "1rem",
               padding: "1rem",
               display: speakers5.display,
            }}
            key={i}
            onClick={() => {
               setModalInfo({
                  name: speaker.firstname + " " + speaker.lastname,
                  bio: speaker.bio,
                  headshotUrl: speaker.speaker_head_shot_to_display,
                  company: speaker.company,
               });
               setOpen(true);
            }}
         >
            <img
               alt='investor'

               src={speaker.speaker_head_shot_to_display}
               style={{ borderRadius: "5px", width: '100%', height: "auto" }}
            />
            <div className="investor-name" style={{ color: "white", fontSize: "1.35rem" }}>
               {speaker.firstname} {speaker.lastname}
            </div>
            <div
               className="turn-red investor-company"
               style={{ color: "#D215E9 !important", fontSize: "1rem" }}
            >
               {speaker.company}
            </div>
         </div>
      </Grid>
   ));

   return (
      <div style={{ backgroundColor: "#212529", justifyContent: 'center' }}>
         <Dialog
            open={open}
            onClose={() => handleClose()}
            sx={{ justifyContent: "center", textAlign: "center" }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogTitle id="alert-dialog-title">
               <div>{modalInfo.name}</div>
               <div>{modalInfo.company}</div>
            </DialogTitle>
            <DialogContent>
               <img alt='investor' src={modalInfo.headshotUrl} />
               <DialogContentText
                  sx={{ marginTop: "1rem" }}
                  id="alert-dialog-description"
               >
                  {modalInfo.bio}
               </DialogContentText>
            </DialogContent>
            <DialogActions>
               <Button onClick={() => handleClose()} variant="secondary" autoFocus>
                  Close
               </Button>
            </DialogActions>
         </Dialog>

         <div style={{ display: 'flex', justifyContent: 'center', padding: window.innerWidth < 900 ? "2% 5%" : '5% 15%' }}>
            <img alt='investor' src={"./assets/media/Fireside Chat.png"} style={{ width: '100%' }} />
         </div>
         <h1
            id="custom-stop"
            style={{
               backgroundColor: "#212529",
               textAlign: "center",
               color: "white",
               fontWeight: "900",
            }}
         >
            MEET OUR FIRST {speakerCountRounded} FEATURED INVESTORS
         </h1>
         <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
            <Box sx={{ flexGrow: 0 }}>
               <Grid
                  container
                  spacing={0}
                  columns={{ xs: 2, sm: 3, md: 5, lg: 5, xl: 5 }}
                  style={{
                     margin: "auto",
                     paddingRight: "5%",
                     justifyContent: 'center',
                     paddingLeft: "5%",
                     maxWidth: '1698px'
                  }}
                  columnSpacing={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }}
               >
                  {firstSpeakerArr}
                  {secondSpeakerArr}
                  {thirdSpeakerArr}
                  {fourthSpeakerArr}
                  {fifthSpeakerArr}
               </Grid>
            </Box>
         </div>
         <div style={{ justifyContent: "center", textAlign: "center" }}>
            <button
               onMouseOver={(e) => {
                  setChevron(1);
                  setMargin1("1.5vw");
               }}
               onMouseLeave={() => {
                  setChevron(0);
                  setMargin1("0vw");
               }}
               className="btn btn-primary mr-2 mb-5 mt-3 text-nowrap dark-btn"
               style={{ marginRight: "1rem", fontWeight: "900", fontSize: "18px" }}
               onClick={() => {
                  if (speakers2.display === "none") {
                     setSpeakers2({ ...speakers2, display: null })
                  }
                  if (speakers2.display === null && speakers3.display === "none") {
                     setSpeakers2({ ...speakers2, display: null })
                     setSpeakers3({ ...speakers3, display: null })
                  }
                  if (speakers2.display === null && speakers3.display === null && speakers4.display === "none") {
                     setSpeakers2({ ...speakers2, display: null })
                     setSpeakers3({ ...speakers3, display: null })
                     setSpeakers4({ ...speakers4, display: null })
                  }
                  if (speakers2.display === null && speakers3.display === null && speakers4.display === null && speakers5.display === 'none') {
                     setSpeakers2({ ...speakers2, display: null })
                     setSpeakers3({ ...speakers3, display: null })
                     setSpeakers4({ ...speakers4, display: null })
                     setSpeakers5({ ...speakers5, display: null });
                  }
               }}
            >
               <div style={{ display: "flex" }}>
                  <ChevronRightIcon sx={{ opacity: "0" }} />
                  <div>{(
                     speakers2.display === null &&
                     speakers3.display === null &&
                     speakers4.display === null &&
                     speakers5.display === null)
                     ? "MORE INVESTORS COMING..." : "SHOW MORE"}</div>
                  <ChevronRightIcon
                     sx={{
                        transition: ".3s all ease-in-out",
                        opacity: chevron,
                        marginLeft: margin1,
                     }}
                  />
               </div>
            </button>
         </div>
      </div>
   );
};
